import axios from 'axios';

export const updateProfile = async values => axios.put(`/profile/user`, { ...values });

export const updatePassword = async values => axios.put(`/profile/user/password`, { ...values });

export const updateEmail = async (userId, oldEmailAddress, newEmailAddress, password, code) =>
  axios.put(`/profile/user/email`, {
    userId,
    oldEmailAddress,
    newEmailAddress,
    password,
    code,
  });

export const deleteAccount = async values => axios.put(`/profile/user/delete`, { ...values });

export default { updateProfile, updatePassword, updateEmail, deleteAccount };
